import { createIcon } from "@chakra-ui/react";

const VisibilityFocusIcon = createIcon({
  displayName: "VisibilityFocusIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.75 4.03469V2H11.25V4.03469C7.43032 4.38984 4.38984 7.43032 4.03469 11.25H2V12.75H4.03469C4.38984 16.5697 7.43032 19.6102 11.25 19.9653V22H12.75V19.9653C16.5697 19.6102 19.6102 16.5697 19.9653 12.75H22V11.25H19.9653C19.6102 7.43032 16.5697 4.38984 12.75 4.03469ZM11.25 5.5428V6.5H12.75V5.5428C15.7405 5.88638 18.1136 8.2595 18.4572 11.25H17.5V12.75H18.4572C18.1136 15.7405 15.7405 18.1136 12.75 18.4572V17.5H11.25V18.4572C8.2595 18.1136 5.88638 15.7405 5.5428 12.75H6.5V11.25H5.5428C5.88638 8.2595 8.2595 5.88638 11.25 5.5428Z"
        fill="currentColor"
      />
    </>
  ),
});

export default VisibilityFocusIcon;
